export default __webpack_public_path__ + "static/media/Unsigned Contract Might.e9147bcc.png";